module.exports = __webpack_public_path__ + "img/lg_ring_r_e_1_null@3x.5f5e883f.png";